module.exports = __webpack_public_path__ + "img/wheel_back.247ce61f.png";